import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Anchor, ArrowNextIcon, Text } from "./ArrowLink.styles";
export var ArrowLink = function(param) {
    var _link = param.link, href = _link.href, label = _link.label;
    return /*#__PURE__*/ _jsxs(Anchor, {
        href: href,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                inline: true,
                textColor: "current",
                children: label
            }),
            /*#__PURE__*/ _jsx(ArrowNextIcon, {})
        ]
    });
};
